import React from "react";
import { ReactContentfulProvider } from "./providers/ReactContentfulProvider";
import { RoutesProvider } from "./providers/RoutesProvider";
import { createClient, AnalyticsProvider } from "@segment/analytics-react";

const segmentClient = createClient({
  writeKey: process.env.REACT_APP_SEGMENT_KEY ?? "",
});

function App() {
  return (
    <AnalyticsProvider client={segmentClient}>
      <ReactContentfulProvider>
        <RoutesProvider />
      </ReactContentfulProvider>
    </AnalyticsProvider>
  );
}

export default App;
